import { Component, Input, OnInit, Output } from '@angular/core';
import { FilterMatchMode, LazyLoadEvent, SelectItem } from 'primeng/api';
import { User } from '../dashboards/user.model';
import { UsersGridService } from './users-grid.service';
import { helperService } from 'src/app/utils/helper';
import { userPmPracticeAreas, userTimeZones } from 'src/app/utils/userData';


@Component({
    selector: 'app-users-grid',
    templateUrl: './users-grid.component.html',
    styleUrls: ['./users-grid.component.scss'],
    standalone: false
})
export class UsersGridComponent implements OnInit {
 
  users: User[]=[];
  cols: any[] =[];
  userDialog: boolean=false;
  viewOnly: boolean=false;
  user: any={};
  newUser:boolean=false;
  matchModeOptionsString?: SelectItem[];
  matchModeOptionsDate?: SelectItem[];
  matchModeOptionsNumber?: SelectItem[];
  title:string="";
  loading:boolean = true;
  totalRecords:number=0;
  first:number=1;
  timeZones:any=[]
  booleanFilterOptions: SelectItem[] = [{label: 'Yes', value: 'Yes'}, {label: 'No', value: 'No'}];
  roles:any[]=[]
  userGridSubscription: any;
  tkPracticeAreas:any[]=[];
  pmPracticeAreas:any[]=[];
  pendingUserAction: { action: 'inactivate' | 'reset'; user: any } | null = null;

  public lastTableLazyLoadEvent: any=null;
  constructor( private userService : UsersGridService,private filterService: helperService) { }

  ngOnInit(): void {
    this.timeZones=userTimeZones;
    this.roles = this.userService.roles;
    this.pmPracticeAreas=userPmPracticeAreas;
    this.cols = [
          { field: 'firstName', header: 'First Name' },
          { field: 'lastName', header: 'Last Name' },
          { field: 'mainEmail', header: 'Main Email' },
          { field: 'isActive', header: 'Is Active' },
          { field: 'finCenId', header: 'Fincen Id' },
          { field: 'phoneNumber', header: 'Main Phone' },
          { field: 'timeZoneCode', header: 'Time Zone' },
          { field: 'roleCodes', header: 'Role' },
          { field: 'userTypeCode', header: 'Type' },
          { field: 'tkPracticeArea', header: 'TK Practice Area' },
          { field: 'pmPracticeArea', header: 'Pm Practice Area' },
          // { field: 'approver', header: 'Approver' },
          { field: 'tkAutoApproval', header: 'is Auto Approver' },
      ];

    this.getTkPracticeArea();
  }

  
  getTkPracticeArea(){
    this.userService.getPracticeArea().subscribe(res=>{
        this.tkPracticeAreas=res.data;
    })
  }

  editUsers(user:any):void{
    // console.log(user);
    // console.log(this.users);
    
    
    this.user=user;
    this.userDialog=true;
    this.viewOnly=false;
    this.newUser=false;
    this.title="Edit User";
  }
  viewUsers(user:any):void{
    this.user=user;
    this.userDialog=true;
    this.viewOnly=true;
    this.newUser=false;
    
    this.title="View User";
    
  }
  closeDialog():void{
    this.userDialog=false;
    this.loadUserData(this.lastTableLazyLoadEvent);
  }

  viewProfile(user: any) {
    this.user=user;
    this.userDialog=true;
    this.viewOnly=true;
    this.newUser=false;
    this.title="Profile Details";
  }

  addUser():void{
    this.user={};
    this.userDialog=true;
    this.viewOnly=false;
    this.newUser=true;
    this.title="Add User";
  }

  loadUserData(event: LazyLoadEvent){
    this.lastTableLazyLoadEvent = event;
    this.loading= true;
    
    event.first=event.first?event.first:1;
    event.rows=event.rows?event.rows:10;
    let payload=this.filterService.generateEventPayload(event);
    if (this.userGridSubscription) 
      this.userGridSubscription.unsubscribe();
    this.userGridSubscription = this.userService.getUsersList(Math.floor(event.first / event.rows + 1), event.rows,payload).subscribe(res => {
      this.users = res.rows;
      this.users.map((obj:any)=>{
        obj.isActive=this.filterService.getStrBoolean(obj.isActive);
      })
      this.loading = false;
      this.totalRecords=res.customValues.totalNumberOfRecords;
    })
  }
  InActivateUser(user:any){
    let paylaod=JSON.parse(JSON.stringify(user));
    paylaod.isActive=!this.filterService.getflagBoolean(user.isActive);
    this.loading = true;
    this.userService.inactivateUser(paylaod).subscribe(res => {
      this.loading = false;
      this.loadUserData(this.lastTableLazyLoadEvent);
    }, error => {
    })
  }

  saveUser():void{
  }

  resetThisUser(user:any){
      
    this.userService.resetUser(user.id).subscribe(res => {
      this.loadUserData(this.lastTableLazyLoadEvent);
    }, error => {
    });
  
  }

  confirmUserAction(action: 'inactivate' | 'reset', user: any): void {
    this.pendingUserAction = { action, user };
  }

  get userActionConfirmMessage(): string {
    const pending = this.pendingUserAction;
    if (!pending) return '';

    const userName = `${pending.user.firstName || ''} ${pending.user.lastName || ''}`.trim() || pending.user.mainEmail;
    if (pending.action === 'reset') return `Are you sure you want to reset MFA ?`;

    const action = pending.user.isActive === 'Yes' ? 'deactivate' : 'activate';
    return `Are you sure you want to ${action} ${userName}?`;
  }

  onUserActionConfirm(answer: string): void {
    const pending = this.pendingUserAction;
    this.pendingUserAction = null;
    if (answer !== 'Yes' || !pending) return;

    if (pending.action === 'reset') this.resetThisUser(pending.user);
    else this.InActivateUser(pending.user);
  }

}
